import type { SessionOrigin } from '@matter_extractor/shared';

/**
 * What the screens say of the ORIGIN of a session or of an interview room
 * (vitrine.md section 8.2, issue #192) - pure, in the voice of the maquette
 * `atelier.html`, section 3: the mark « prod » next to the version, the filter
 * « Origine », its chip.
 *
 * `prod` is a session (or a room) the synchronisation brought up from the
 * vitrine; `dev` is one born on this server. The mark exists ONLY for `prod`: an
 * ordinary session carries nothing, so the list reads exactly as it did before.
 */

/** The word of the mark, and of the option of the filter. */
export const SESSION_ORIGIN_LABEL: Readonly<Record<SessionOrigin, string>> = {
  prod: 'prod',
  dev: 'dev',
};

export function isSessionOrigin(value: unknown): value is SessionOrigin {
  return value === 'prod' || value === 'dev';
}

/** Whether a row (a session, a room) wears the mark: absent reads `dev`. */
export function isProdOrigin(row: { readonly origin?: SessionOrigin | undefined }): boolean {
  return row.origin === 'prod';
}

/** « Origine : prod » - the chip that unarms the filter. */
export function originFilterChipLabel(origin: SessionOrigin): string {
  return `Origine : ${SESSION_ORIGIN_LABEL[origin]}`;
}

/** The sentence under the mark on the head of a parcours or of a conversation. */
export const PROD_SESSION_LINE =
  'Session de la prod, remontée par la synchronisation : elle se relit et se rejoue à blanc ici, elle ne se reprend pas.';
